import React from 'react';

interface ControlsProps {
  selectedMonth: string;
  onMonthChange: (month: string) => void;
}

export const DashboardControls: React.FC<ControlsProps> = ({ selectedMonth, onMonthChange }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center mb-6 space-y-4 md:space-y-0">
      <h3 className="text-lg font-medium text-gray-700">Dữ liệu giả lập mô hình Titan + Pioneer</h3>
      <div className="flex space-x-2">
        <select
          value={selectedMonth}
          onChange={(e) => onMonthChange(e.target.value)}
          className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-900 focus:border-transparent"
        >
          <option value="1">Tháng 1</option>
          <option value="2">Tháng 2</option>
          <option value="3">Tháng 3</option>
        </select>
      </div>
    </div>
  );
};